import React, { useEffect, useState } from 'react';
export function ScriptLoader({ url = '', id = '' }) {
    const [isLoaded, setIsLoaded] = useState(false);
    useEffect(() => {
        const script = document.createElement('script');
        script.src = url;
        script.id = id;
        script.onload = () => setIsLoaded(true);
        document.head.appendChild(script);
        return () => {
            document.head.removeChild(script);
        };
    }, [id, url]);
    if (!url || !isLoaded) {
        return null;
    }
    return React.createElement("div", null);
}
